import moment from 'moment';
import CardScheduleSessions from './CardScheduleSessions';
import CardScheduleClass from './CardScheduleClass';

const ListSection = ({ item, pickDate, type }) => {
  const formatPickDate = (paramsDate) => {
    const isToday = moment(paramsDate).isSame(moment(), 'day');

    const dayLabel = isToday ? 'Today, ' : '';
    const formattedDate = moment(paramsDate).format('dddd D MMMM');

    return `${dayLabel}${formattedDate}`;
  };

  return (
    <div className="px-6 pt-2 relative overflow-hidden">
      <div className="flex flex-col items-start md:flex-row  md:items-center justify-between mb-4">
        <span className="text-base text-primary-main font-bold">{formatPickDate(pickDate)}</span>
        <span className="text-sm text-kin-text font-light">2 Play Sessions</span>
      </div>
      <div className="flex flex-col gap-4 h-[300px] overflow-y-scroll">
        {[...Array(6)].map((itm, idx) => {
          return (
            <div key={idx}>
              {item.class ? (
                <CardScheduleClass item={item} type={type} />
              ) : (
                <CardScheduleSessions item={item} type={type} />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ListSection;
